<template>
  <v-row justify="center" class="fill-height">
    <v-col cols="2" class="my-auto text-center">
      <v-progress-circular indeterminate color="primary" size="50" class="mb-3" />
      <p>Redirecting..</p>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import { useUserStore } from '@/stores/modules/user'
  import CONSTANTS from '@/constants/Config.constants'

  const router = useRouter()
  const store = {
    authStore: useStore(),
    userStore: useUserStore(),
  }

  onMounted(async () => {
    try {
      const redirectPath = await store.authStore.dispatch('oidcSignInCallback')
      router.push(redirectPath)
    } catch (error) {
      console.error('Could not dispatch signin callback', error)
      router.push(CONSTANTS.BASE_ROUTES.HOME)
    }
  })
</script>
